import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import DeviationSelector from '../../DeviationSelector';
import withGallectionDeviations from '../../../_hocs/withCurrentGallectionDeviations';
import withCurrentSubfolder from '../../../_hocs/withCurrentSubfolder';
import LoadingIndicator from '../../../../LoadingIndicator';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SearchInput from '../../../_partials/SearchInput';
import SubfolderSlider from '../../../_partials/SubfolderSlider';
import withSearch from '../../../_hocs/withSearch';
import NoSearchResults from '../../../_partials/NoSearchResults';
import withFileUpload from '../../../_hocs/withFileUpload';
import Flex from '../../../../Flex';
var enhance = compose(withGallectionDeviations, withCurrentSubfolder, withSearch, withFileUpload, withTranslation());
var GallectionDeviationSelector = /** @class */ (function (_super) {
    __extends(GallectionDeviationSelector, _super);
    function GallectionDeviationSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchMoreGallectionDeviationsIfNeeded = function () {
            var _a = _this.props, hasMore = _a.hasMore, isFetching = _a.isFetching, fetchMoreGallectionDeviations = _a.fetchMoreGallectionDeviations;
            if (!hasMore || isFetching) {
                return;
            }
            fetchMoreGallectionDeviations();
        };
        return _this;
    }
    GallectionDeviationSelector.prototype.render = function () {
        var currentSubfolderId = this.props.currentSubfolderId;
        return (React.createElement(PopupInnerLayout, { headerExtrasRightZone: React.createElement(SearchInput, null), headerExtrasBottomZone: React.createElement(React.Fragment, null,
                !currentSubfolderId && React.createElement(SubfolderSlider, null),
                React.createElement(SelectedItemsPanel, null)), scrollableContent: this.renderContent(), onScrolledToBottom: this.fetchMoreGallectionDeviationsIfNeeded, onNotScrollable: this.fetchMoreGallectionDeviationsIfNeeded }));
    };
    GallectionDeviationSelector.prototype.renderContent = function () {
        var _a = this.props, isInitialized = _a.isInitialized, isFetching = _a.isFetching, fileUploads = _a.fileUploads, hasMore = _a.hasMore, deviations = _a.deviations;
        return (React.createElement(React.Fragment, null,
            isInitialized &&
                (!deviations.length &&
                    !fileUploads.length &&
                    !isFetching &&
                    !hasMore ? (this.renderEmpty()) : (React.createElement(DeviationSelector, { deviations: deviations }))),
            (!isInitialized || isFetching) && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !hasMore && !isFetching }))));
    };
    GallectionDeviationSelector.prototype.renderEmpty = function () {
        var _a = this.props, t = _a.t, searchQuery = _a.searchQuery;
        if (searchQuery) {
            return React.createElement(NoSearchResults, null);
        }
        return (React.createElement(Flex, { fullWidth: true, fullHeight: true, direction: "column", justifyContent: "center", alignItems: "center" }, t('mediapopup.emptyFolder')));
    };
    return GallectionDeviationSelector;
}(React.Component));
export { GallectionDeviationSelector };
export default enhance(GallectionDeviationSelector);
//# sourceMappingURL=GallectionDeviationSelector.connected.js.map